import { getClientCityToCityListRequest } from "../../data/clientCityToCityApi";

function getResponseData(response) {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  return [];
}

export async function getClientCityToCityListUseCase() {
  return getResponseData(await getClientCityToCityListRequest());
}
